import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { makeStyles } from '@material-ui/core';
import {
  BACKGROUND_DARK,
  BACKGROUND_WHITE,
  CANCEL_COLOR,
  OK_COLOR,
  VERY_LIGHT_GREY_COLOR,
} from '../../const/color-const';
import classNames from 'classnames';
import Box from '@material-ui/core/Box';
import { GridCloseIcon } from '@material-ui/data-grid';
import { darken } from '@material-ui/core/styles';
import { Check, Clear } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  promptPopup: {
    background: theme.palette.type === 'light' ? BACKGROUND_WHITE : BACKGROUND_DARK,
    position: 'relative',
    fontSize: 16,
    margin: 0,
    '& svg': {
      cursor: 'pointer',
    },
  },
  promptHeader: {
    top: 0,
    left: 0,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    justifyContent: 'flex-end',
    background: theme.palette.type === 'light' ? BACKGROUND_WHITE : BACKGROUND_DARK,
    padding: theme.spacing(1, 2, 1, 1),
    borderBottom: `1px solid ${VERY_LIGHT_GREY_COLOR}`,
    '& p': {
      margin: theme.spacing(2, 0, 2, 0),
    },
  },
  message: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(2),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center',
  },
  promptBtn: {
    width: 100,
    borderRadius: 4,
    textTransform: 'capitalize',
    color: 'white',
  },
  promptOk: {
    background: OK_COLOR,
    '&:hover': {
      background: darken(OK_COLOR, 0.3),
    },
  },
  promptCancel: {
    background: CANCEL_COLOR,
    '&:hover': {
      background: darken(CANCEL_COLOR, 0.3),
    },
  },
}));

const CustomPrompt = ({ message, cleanUp, onCancel, cancelText, confirmText }) => {
  const styles = useStyles();
  
  const cancel = () => {
    cleanUp(false);
    onCancel && onCancel();
  };
  
  const ok = () => cleanUp(true);
  
  return (
    <Dialog open={true} onClose={cancel}>
      <DialogContent className={styles.promptPopup}>
        <Box className={styles.promptHeader}>
          <GridCloseIcon onClick={cancel} />
        </Box>
        <DialogContentText className={styles.message} id="alert-dialog-description">
          {message}
        </DialogContentText>
        <DialogActions className={styles.buttons}>
          <Button className={classNames(styles.promptBtn, styles.promptCancel)} onClick={cancel}>
            {cancelText ? cancelText : <Clear />}
          </Button>
          <Button className={classNames(styles.promptBtn, styles.promptOk)} onClick={ok}>
            {confirmText ? confirmText : <Check />}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default CustomPrompt;